.alert {
  margin: var(--core-metrics-spacing-600) 0;
}
